$(function () {
	$('.quote-list').on('click', '.slick-slide', function () {
		$('.youtube_box').show()
		$('.youtube_box_iframe').attr(
			'src',
			$(this).find('.play-button').attr('data-youtubeSrc')
		)
	})
	$('.latest-list').on('click', '.tt-play', function () {
		$('.youtube_box').show()
		$('.youtube_box_iframe').attr(
			'src',
			$(this).find('.play-button').attr('data-youtubeSrc')
		)
	})
	$('.youtube_box .close ').on('click', function () {
		$('.youtube_box').hide()
		$('.youtube_box_iframe').attr('src', '')
	})

	function paly() {
		var _videos = $('.video video')
		let index = $('.video .slick-current').index()
		for (var j = 0; j < _videos.length; j++) {
			if (index != j) {
				_videos[j].pause()
				_videos[j].currentTime = 1
			} else {
				_videos[j].play()
			}
		}
	}
	paly()
	$('.video .slick-next').click(function () {
		paly()
	})
	$('.video .slick-prev').click(function () {
		paly()
	})
	$('.quote-list .slick-arrow').hide()
	$('.quote-list').hover(
		function () {
			$('.quote-list .slick-arrow').show()
		},
		function () {
			$('.quote-list .slick-arrow').hide()
		}
	)
	$('.experts .slick-arrow').hide()
	$('.experts').hover(
		function () {
			$('.experts .slick-arrow').show()
		},
		function () {
			$('.experts .slick-arrow').hide()
		}
	)
	$('.header-new .tt-desctop-menu ul .tt-submenu').hover(
		function () {
			$('.header-new .tt-submenu').removeClass('active')
			$('.header-new .tt-submenu .dropdown-menu').removeClass('hover')
			// $('.header-new .tt-submenu .dropdown-menu').hide()
			$(this).addClass('active')
			// $(this).find('.dropdown-menu').show()
		},
		function () {
			$('.header-new .tt-submenu').removeClass('active')
			$('.header-new .tt-submenu .dropdown-menu').removeClass('hover')
			$('.header-new .tt-submenu .dropdown-menu').hide()
		}
	)
	let idx = $('.deals-nav .active').index()
	$('.deals-nav p').click(function () {
		let index = $(this).index()
		$('.deals-nav p').removeClass('active')
		$(this).addClass('active')
		if (index === 0)
			$('.deals-item.first-page').parent('.shopify-section')[0].scrollIntoView({ behavior: 'smooth' })
		if (index === 1)
			$('.deals-item.second-page').parent('.shopify-section')[0].scrollIntoView({ behavior: 'smooth' })
	})
	function execCoy(text) {
		const input = document.createElement('INPUT')
		input.style.opacity = 0
		input.style.position = 'absolute'
		input.style.left = '-100000px'
		document.body.appendChild(input)
		input.value = text
		input.select()
		input.setSelectionRange(0, text.length)
		document.execCommand('copy')
		document.body.removeChild(input)
		return true
	}
	$('.gift-item .copy-btn').click(function (e) {
		let code_number = $(this).siblings('.code').text()
		execCoy(code_number)
	})
	$('.off .copy-btn').click(function (e) {
		$(this).text('Copied').addClass('active')
		let code_number = $(this).siblings('.code').text()
		execCoy(code_number)
	})
	var currentCartUrl = $(".gift-item .col-md-3.active").find(".deals-card-item").data("cart-url")
	var currentLearnUrl = $(".gift-item .col-md-3.active").find(".deals-card-item").data("learn-url")
	$("#deals-pick-btn1").attr("href",currentCartUrl)
	$("#deals-pick-btn2").attr("href",currentLearnUrl)
	$('.gift-item .col-md-3').click(function (e) {
		$('.gift-item .col-md-3').removeClass('active')
		$(this).addClass('active')
		var currentCartUrl = $(this).find(".deals-card-item").data("cart-url")
		var currentLearnUrl = $(this).find(".deals-card-item").data("learn-url")
		$("#deals-pick-btn1").attr("href",currentCartUrl)
		$("#deals-pick-btn2").attr("href",currentLearnUrl)
		e.stopPropagation()
	})
	$('.best-item .copy-btn').click(function (e) {
		let code_number = $(this).siblings('.code').text()
		execCoy(code_number)
	})
	$('.emotn-list-row').on('click', '.copy-btn', function (e) {
		let code_number = $(this).siblings('.code').text()
		execCoy(code_number)
	})
	$('.mars-pro').on('click', '.paly-btn', function () {
		$(this).hide()
		$('.mars-pro video').show()
    $('.mars-pro video')[0].play()
	})
	$('.selling-point-nav .col-md-6').eq(0).addClass('show_a')
	$('.selling-point-cont').parent('.shopify-section').hide()
	$('.selling-point-cont').eq(0).parent('.shopify-section').show()
	$('.selling-point-nav .col-md-6').hover(function () {
		let index = $(this).index()
		$('.selling-point-nav .col-md-6').removeClass('show_a')
		$(this).addClass('show_a')
		$('.selling-point-cont').parent('.shopify-section').hide()
		$('.selling-point-cont').eq(index).parent('.shopify-section').show()
	})
	$('.selling-point-nav .col-md-6').click(function () {
		return false
	})
	window.addEventListener('scroll', handleScroll, true)
	window.addEventListener('resize', handleScroll, true)
	function handleScroll() {
		var scroll = document.documentElement.scrollTop || document.body.scrollTop,
			headerH = $('.header-new').height(),
			cl = $('.col-sm-12').length,
			ph = $('.col-sm-12').height(),
			wii = window.innerHeight,
			tsn = $('.sticky-nav').height(),
			ftd = $('.footer-cart').innerHeight()
    if(window.innerWidth > 750){
      $('.simple-anim .col-12-440width').css('height', (980 / 19.2) + 'vw')
    }else{
      $('.simple-anim .col-12-440width').css('height', 'auto')
    }
		if (scroll > headerH) {
			$('.sticky-nav').addClass('active')
		} else {
			$('.sticky-nav').removeClass('active')
		}
		$('.col-sm-12')
			.find('.tt-description-wrapper')
			.addClass('transi-up delay-1')
		for (let i = 0; i < cl; i++) {
			let offsetTop = $('.col-sm-12').eq(i).offset().top
			if (scroll > offsetTop - ph + 200) {
				$('.col-sm-12').eq(i).addClass('is-visible')
			}
		}
		// 添加动画
		$('.custom-simple-banner-section')
			.find('.custom-simple-banner-box-text')
			.addClass('transi-up delay-1')
		var textsLen = $('.custom-simple-banner-section').length
		var showHeight = window.innerHeight > 750 ? 200 : 500
		for (let i = 0; i < textsLen; i++) {
			let offsetTop = $('.custom-simple-banner-section').eq(i).offset().top
			if (scroll > offsetTop - showHeight) {
				$('.custom-simple-banner-section').eq(i).addClass('is-visible')
			}
		}
		if (document.querySelector('.roll-page')) {
      if(window.innerWidth > 750){
        $('.simple-anim .roll-page').css('height', (wii - tsn - ftd) * 2 + 'px')
			  $('.simple-anim .roll-page a').css('height', wii - tsn - ftd + 'px')
      }
			let rp = document.querySelector('.roll-page')
			let ot = document.querySelector('.simple-anim').offsetTop + rp.offsetTop
			let rh = $('.simple-anim .roll-page').height()
			if (scroll > ot && scroll < ot + rh/2) {
				rp.style.transform =
					'translate(' + (scroll - ot) + 'px,' + (scroll - ot + 65) + 'px)'
			} else {
				rp.style.marginTop = -rh / 2 + 'px'
				rp.style.transform = 'translate(0,0)'
			}
		}
	}
	if (document.querySelector('.custom-lookbook-anim')) {
		let height = $('.custom-lookbook-anim .col-12-440width').height()
		$('.custom-lookbook-anim .container-fluid-custom').css(
			'height',
			height * 3 + 'px'
		)
		var e = document.querySelector('.custom-lookbook-anim'),
			a = e.offsetTop,
			c = (scroll - a) / height,
			sw = document.querySelectorAll('.col-12-440width')
		sw[0].style.opacity = '1'
		if (c > 0 && c <= 1) {
			sw[2].style.opacity = '0'
			sw[0].style.opacity = ''.concat(1.5 - c)
			sw[1].style.opacity = '1'
			sw[1].style.transform = 'translateY(' + (a - scroll) + 'px)'
		} else if (c > 1 && c <= 2) {
			sw[0].style.opacity = '0'
			sw[1].style.transform = 'translateY(' + -height + 'px)'
			sw[1].style.opacity = ''.concat(2.5 - c)
			sw[2].style.opacity = '1'
			sw[2].style.transform = 'translateY(' + (a - scroll) + 'px)'
		}
	}
	$('.level-sort .nav-item .nav-link').click(function () {
		var idx = $(this).parent('.nav-item').index()
		if ($(this).attr('aria-selected') == 'true') {
			$(this).attr('aria-selected', 'false')
			$(this).removeClass('showicon')
			$('.level-sort .tab-design').eq(idx).removeClass('showicon')
			$('.level-sort .tab-content').css(
				'background-image',
				'url(https://cdn.shopify.com/s/files/1/0582/1127/0815/files/6a29f17f2d83bd4e62926593b6aa3d49_1959e72a-6dfb-46db-96bd-b34cc879add2.png?v=1685596942)'
			)
		} else {
			$(this).attr('aria-selected', 'true')
			$('.level-sort .tab-content').css('background-image', 'url()')
			$('.level-sort .nav-item .nav-link').removeClass('showicon')
			$(this).addClass('showicon')
			$('.level-sort .tab-design').removeClass('showicon')
			$('.level-sort .tab-design').eq(idx).addClass('showicon')
		}
	})
	$('.faq-cont')
		.parent('.index-section')
		.css({ height: '0', paddingBottom: '0', overflow: 'hidden' })
	$('.faq-cont')
		.eq(0)
		.parent('.index-section')
		.css({ height: 'auto', paddingBottom: '100px', overflow: 'hidden' })
	$('.faq-nav li').click(function () {
		let index = $(this).index()
		$('.faq-nav li').removeClass('active')
		$(this).addClass('active')
		$('.faq-cont')
			.parent('.index-section')
			.css({ height: '0', paddingBottom: '0', overflow: 'hidden' })
		$('.faq-cont')
			.eq(index)
			.parent('.index-section')
			.css({ height: 'auto', paddingBottom: '100px', overflow: 'hidden' })
	})
	// neo
	$('.tt-description').on('click', '.WK74moyP', function () {
		$('.Ef4_4LFl').show()
		setTimeout(function(){
			var v = $('.Ef4_4LFl').find('video')[0]
			if (v) v.play()
		}, 200)
	})
	$('.tt-description').on('click', '.__6K7_oZQh', function () {
		$('.Ef4_4LFl').hide()
		var v = $('.Ef4_4LFl').find('video')[0]
		if (v) v.pause()
	})
	// faq
	$('.faq-container .tt-box-faq-listing h3').click(function () {
		if ($(this).hasClass('active')) {
      $(this).removeClass("active")
			$(this).siblings('p').hide()
		} else {
			$(this).siblings('p').show()
      $(this).addClass("active")
		}
	})
})
